import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
	selector: 'sl-button-bar',
	templateUrl: './button-bar.component.html',
	styleUrls: ['./button-bar.component.less'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [NgIf, NgFor, MatButtonModule, MatMenuModule, MatIconModule],
})
export class ButtonBarComponent implements OnDestroy {
	@Input() saveDisabled = false;
	@Input() saveHidden = false;
	@Input() saveText = 'Save';
	@Input() cancelDisabled = false;
	@Input() cancelHidden = false;
	/**
	 * Custom buttons to show in a menu next to the save button.
	 */
	@Input() saveMenuButtons: { text: string; action: () => any }[] = [];

	@Output() canceled = new EventEmitter<any>();
	@Output() submitted = new EventEmitter<any>();

	bodyCssClass = 'has-button-bar';

	constructor(private readonly renderer: Renderer2) {
		this.renderer.addClass(document.body, this.bodyCssClass);
	}

	ngOnDestroy(): void {
		this.renderer.removeClass(document.body, this.bodyCssClass);
	}

	onCancel(): void {
		this.canceled.emit();
	}

	onSubmit(): void {
		this.submitted.emit();
	}
}
